import React, { useState } from 'react';
import OtpVerification from '../otp-verification/otp-verification.component';
import EmailForm from './email-form.component';
import { UserPersonalInfo } from '../../../stores/types/user.types';
import { i18n } from '../../../services/translation/i18n';
import { useUserProfile } from '../../../hooks/useUserProfile';
import { UserMode } from '../types/user-mode.enum';
import { BackButtonHeader } from '../../ui-components/back-button-header.component';
import { useLogger } from '../../../services/logging/logger-context';

interface IProps {
  currentUser: UserPersonalInfo;
  handleUserView: Function;
}

const EditEmail = ({ currentUser, handleUserView }: IProps) => {
  const [verifyOtp, setVerifyOtp] = useState(false);
  const [email, setEmail] = useState(currentUser?.email || '');
  const [otpError, setOtpError] = useState<boolean>(false);

  const { updateUserEmail, verifyEmailCode, resendEmailVerification } = useUserProfile();
  const isCurrentEmail = email === currentUser?.email;
  const { logger } = useLogger();
  const verifyUserEmail = async () => {
    try {
      await updateUserEmail(email.trim());
      setVerifyOtp(true);
      setOtpError(false);
    } catch (e) {
      logger.error('Failed to update user email', e);
      setOtpError(true);
    }
  };

  const verifyEmailValidationCode = async (code) => {
    try {
      await verifyEmailCode(code);
      handleUserView(UserMode.NONE);
    } catch (e) {
      setOtpError(true);
    }
  };

  const resendOtp = async () => {
    await resendEmailVerification();
  };

  const onClickBack = () => {
    handleUserView(UserMode.NONE);
  };

  return (
    <>
      {verifyOtp ? (
        <>
          <BackButtonHeader title={i18n.t('verify_email')} onBackArrowClicked={onClickBack} />
          <OtpVerification
            otpLength={6}
            verifyUser={email}
            handleVerifyOtp={verifyEmailValidationCode}
            sendNewCode={resendOtp}
            error={otpError}
            setError={setOtpError}
            description={'we_have_sent_a_code'}
            description1={i18n.t('enter_code_to_verify_email')}
          />
        </>
      ) : (
        <EmailForm
          isCurrentEmail={isCurrentEmail}
          setView={handleUserView}
          setVerifyOtp={setVerifyOtp}
          email={email}
          setEmail={setEmail}
          handleSubmitEmail={verifyUserEmail}
          isEmailVerified={currentUser?.email_verified}
        />
      )}
    </>
  );
};

export default EditEmail;
